export default __webpack_public_path__ + "images/69704ec19657286e2136de8fa6f2241a-electronic_music.jpg";